import Button from '@components/v2/ui/Button/Button';
import LabeledChip from '@components/v2/ui/LabeledChip/LabeledChip';
import LangEnum from '../../../../../../lang/LangEnum';
import { useTranslation } from '../../../../../translation/TranslationContext';
import { CATALOG_LIST_ROW_TAB_INDEX } from '../utils/catalogListRow.consts';
import { CHIP_BUTTON_SX } from './CatalogListCombinationChips';

const CatalogListKitChip = () => {
  const { translate } = useTranslation();

  return (
    <Button
      variant="text"
      size="small"
      isActive
      tabIndex={CATALOG_LIST_ROW_TAB_INDEX}
      sx={CHIP_BUTTON_SX}
    >
      <LabeledChip appearance="plain" content={translate(LangEnum.CATALOGS_LIST_KIT_COMBINATION)} />
    </Button>
  );
};

export default CatalogListKitChip;
